import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import UnsubscribedUsersReport from './UnsubscribedUsersReport';

const EmailUnsubscribesRouter = () => {
    let { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={`${path}/report`}>
                <UnsubscribedUsersReport />
            </Route>
            <Route default>
                <UnsubscribedUsersReport />
            </Route>
        </Switch>
    );
};

export default EmailUnsubscribesRouter;
